import React from 'react'
import header from './HeaderContact.module.scss'
import HeaderButton from '../../components/HeaderButton/HeaderButton'

const HeaderContact = ({isOpen}) => {

    return (
        <div className={header.contacts}>
            <HeaderButton/>
            <div className={header.box_phone}>
                <a className={header.phone}  href="tel:+74957412796" target='_blank' rel='noopener noreferrer'>+7 (495) 741-27-96</a>
            </div>
        </div>
    );
};

export default HeaderContact